import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { ApiQuery } from '../../core/api/entities/api-query.entity';
import { FacetProfileField } from '../../core/profiles/entities/profile-field.entity';
import { ShFacet } from '../../elements/components/facet/entities/facet.entity';
import { COMPLETABLE_TASK_FACET } from '../constants/virtual-facets.constants';
import { FacetValueConstraint, TaskFacetRequest } from '../entities/facet-request.entity';
import { FacetsResponseToShFacets } from '../helpers/facet-response.helper';
import { ShFacetDataService } from './facet.data-service';

@Injectable({ providedIn: 'root' })
export class ShTaskFacetDataService extends ShFacetDataService {
    protected FACETS_ENDPOINT = 'workflow/api/tasks/facets';

    // #region Get Facets by Profile

    /**
     * Get all facets of a profile
     * @param query
     * @param profileId
     * @param facetProfileFields
     * @param onlyCompletable
     * @returns
     */
    public getProfileFacets(
        query: ApiQuery,
        profileId: string,
        facetProfileFields: FacetProfileField[],
        onlyCompletable: boolean = false
    ): Observable<ShFacet[]> {
        query.deleteFieldIfPresent(COMPLETABLE_TASK_FACET);
        const facetRequest: TaskFacetRequest = this.getProfileFacetRequest(query, profileId) as TaskFacetRequest;
        facetRequest.Search.OnlyCompletable = onlyCompletable;

        return this.getFacets(facetRequest).pipe(map(facets => FacetsResponseToShFacets(facets, facetProfileFields)));
    }
    // #endregion

    // #region Get Facet by ProfileField

    /**
     * Get values of specific ProfileField
     * Constraint options allow you to retrieve extra pages, search for a specific value,...
     *
     * @param query
     * @param facetProfileField
     * @param constraint
     * @param onlyCompletable
     * @returns
     */
    public getProfileFieldFacet(
        query: ApiQuery,
        facetProfileField: FacetProfileField,
        constraint: FacetValueConstraint,
        includeActiveValues: boolean,
        onlyCompletable: boolean = false
    ): Observable<ShFacet> {
        query.deleteFieldIfPresent(COMPLETABLE_TASK_FACET);

        const facetRequest: TaskFacetRequest = this.getProfileFieldFacetRequest(
            query,
            facetProfileField,
            constraint,
            includeActiveValues
        ) as TaskFacetRequest;

        facetRequest.Search.OnlyCompletable = onlyCompletable;

        return this.getFacets(facetRequest).pipe(
            map(facets => FacetsResponseToShFacets(facets, [facetProfileField])[0])
        );
    }
    // #endregion
}
